import { SITE_ORIGIN_FALLBACK } from '~shared/seo'

function originFromCandidate(raw: string): string | null {
  const t = raw.trim()
  if (!t) return null
  try {
    const withProto = /^https?:\/\//i.test(t) ? t : `https://${t}`
    return new URL(withProto).origin.replace(/\/$/, '')
  } catch {
    return null
  }
}

/** Public site origin for canonical/OG URLs; production builds set `VITE_SITE_ORIGIN`. */
export function clientSiteOrigin(): string {
  const fromEnv = typeof import.meta !== 'undefined' ? import.meta.env?.VITE_SITE_ORIGIN : undefined
  const envOrigin = typeof fromEnv === 'string' ? originFromCandidate(fromEnv) : null
  if (envOrigin) return envOrigin
  return typeof window !== 'undefined' ? window.location.origin : SITE_ORIGIN_FALLBACK
}
